import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/revendedores/autogestion/autogestion-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/revendedores/autogestion/login-prompt.tsx");
